// Vendor styles
import 'noty/lib/noty.css';
import 'remodal/dist/remodal.css';
import 'remodal/dist/remodal-default-theme.css';

// Vendor JS
import '@uirouter/angularjs';
import 'angular';
import 'angular-animate';
import 'angular-aria';
import 'angular-cookies';
import 'angular-local-storage';
import 'angular-messages';
import 'angular-resource';
import 'angular-sanitize';
import 'angular-touch';
import 'angular-translate';
import 'angular-translate-loader-static-files';
import 'he';
import 'jquery';
import 'jquery-ui/ui/widgets/autocomplete';
import 'jquery-ui/ui/widgets/dialog';
import 'ng-device-detector';
import 'ng-mask';
import 'ng-meta';
import 'remodal';
import 'tingle.js';




// WEBPACK FOOTER //
// src/vendor.ts